import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles(theme => ({
  estimateRowContainer: {
    width: '100% !important',
    margin: theme.spacing(0),
    padding: theme.spacing(0.5, 2, 0, 1)
  },
  estimateCardContainer: {
    height: theme.spacing(9)
  },
  allocationCardContainer: {
    minWidth: theme.spacing(30),
    maxWidth: theme.spacing(30),
    margin: theme.spacing(0, 1, 0, 1)
  },
  roleContainer: {
    width: '100% !important',
    margin: theme.spacing(0),
    minWidth: theme.spacing(10),
    padding: theme.spacing(1.5, 0, 0, 3)
  },
  messageContainer: {
    width: '100% !important',
    margin: theme.spacing(1, 0, 0, 0),
    padding: theme.spacing(0, 2, 0, 3)
  }
}));

export const RemoveTaskAssignmentDialogContentSkeleton = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.roleContainer}>
        <Skeleton width={175} height={45} variant="rect" />
      </Grid>
      <Grid container className={classes.estimateRowContainer}>
        <Grid item className={classes.allocationCardContainer}>
          <Skeleton width={240} height={55} variant="rect" />
        </Grid>
      </Grid>
      <Grid container className={classes.messageContainer}>
        <Skeleton width="100%" height={65} variant="rect" />
      </Grid>
    </>
  );
};

RemoveTaskAssignmentDialogContentSkeleton.propTypes = {};

export default RemoveTaskAssignmentDialogContentSkeleton;
